import { SearchInput } from '@shared/components'
import { Space } from 'antd'
import { useTranslation } from 'react-i18next'

export const LogApplicationsHeader = () => {
  const { t } = useTranslation()

  return (
    <Space>
      <SearchInput placeholder={t('common.search')} />
    </Space>
  )
}
